import "bootstrap-icons/font/bootstrap-icons.css";
import "remixicon/fonts/remixicon.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.js";
import { useEffect } from "react";

import { useNavigate } from "react-router-dom";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";

import "./App.css";
import Header from "./components/Header/Header";
import SideBar from "./components/Dashboard/SideBar";
import Main from "./components/Dashboard/Main";
import UserMain from "./components/Users/Usermain";
import Login from "./components/Login/Login";
import Reportmain from "./components/Reports/Reportmain";
import ProtectedRoute from "./components/Dashboard/ProtectedRoute";
import PerformancePage from "./components/Reports/PerformancePage";
import Paymentmain from "./components/Payment/paymentmain";

import useIdleTimer from "./useIdleTimer";
import Screenmain from "./components/Screener/Screenmain";
import Trackmain from "./components/Tracker/Trackmain";
import TradeTrackmain from "./components/TradeTracker/TradeTrackmain";
import MomentumTradesmain from "./components/MomentumTrades/MomentumTrades";
import MomentumTrackmain from "./components/MomentumTrack/MomentumTrackmain";
import MomentumPublicView from "./components/MomentumTrack/MomentumPublicView"; // ← ADD THIS

function App() {
  const location = useLocation();
  const navigate = useNavigate();

  const normalizedPath = location.pathname.replace(/\/+$/, "");
  const isLoginPage = normalizedPath === "/login";
  const isPerformancePage = normalizedPath.startsWith("/performance");
  const isSharePage = normalizedPath.startsWith("/share"); // ← ADD THIS

  const handleIdle = () => {
    console.log("User is inactive. Logging out...");
    navigate("/login");
  };

  useEffect(() => {
    if (location.pathname.endsWith("/") && location.pathname !== "/") {
      navigate(location.pathname.slice(0, -1), { replace: true });
    }
  }, [location.pathname]);

  useIdleTimer(3 * 60 * 60 * 1000, handleIdle);

  return (
    <>
      {/* Hide Header and SideBar on login, performance, and share pages */}
      {!isLoginPage && !isPerformancePage && !isSharePage && <Header />}
      {!isLoginPage && !isPerformancePage && !isSharePage && <SideBar />}

      <main id="Route" className="Route">
        <Routes>
          <Route path="/" element={<Navigate to="/login" />} />
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/share/:token" element={<MomentumPublicView />} />{" "}
          {/* ← ADD THIS */}
          {/* Protected routes */}
          <Route
            path="/Dashboard"
            element={
              <ProtectedRoute>
                <Main />
              </ProtectedRoute>
            }
          />
          <Route
            path="/User"
            element={
              <ProtectedRoute>
                <UserMain />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Report"
            element={
              <ProtectedRoute>
                <Reportmain />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Screener"
            element={
              <ProtectedRoute>
                <Screenmain />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Track"
            element={
              <ProtectedRoute>
                <Trackmain />
              </ProtectedRoute>
            }
          />
          <Route
            path="/TradeTrack"
            element={
              <ProtectedRoute>
                <TradeTrackmain />
              </ProtectedRoute>
            }
          />
          <Route
            path="/MomentumTrack"
            element={
              <ProtectedRoute>
                <MomentumTrackmain />
              </ProtectedRoute>
            }
          />
          <Route
            path="/MomentumTrades"
            element={
              <ProtectedRoute>
                <MomentumTradesmain />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Payment"
            element={
              <ProtectedRoute>
                <Paymentmain />
              </ProtectedRoute>
            }
          />
          <Route
            path="/performance/:encodedClientId"
            element={<PerformancePage />}
          />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </main>
    </>
  );
}

function AppWrapper() {
  return (
    <Router>
      <App />
    </Router>
  );
}

export default AppWrapper;
